export default defineNuxtPlugin(() => {
    const api = $fetch.create({
        baseURL: useRuntimeConfig().public.BASE_URL,
        onRequest ({ options }) {},
        async onResponseError ({ response }) {},
    })

    return {
        provide: { api }
    }
});